import PublishIcon from "@mui/icons-material/Publish";
import { Button, Tooltip } from "@mui/material";

/** Ingests the run; when it can't, the button is disabled with the reason in its tooltip. */
export function IngestPipelineButton({
  onClick,
  disabledReason,
}: {
  onClick: () => void;
  /** Why ingesting is not possible right now; undefined when it is. */
  disabledReason: string | undefined;
}) {
  return (
    <Tooltip title={disabledReason ?? ""}>
      <span>
        <Button
          variant="contained"
          startIcon={<PublishIcon />}
          onClick={onClick}
          disabled={disabledReason !== undefined}
          // Sits in the flex header row; keep the label on one line when the title is long.
          sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
        >
          Ingest Pipeline
        </Button>
      </span>
    </Tooltip>
  );
}
